export default class ownersvoiceManager {
    constructor(param) {

        this.kv = document.getElementById("p-kv");
        this.kvBg = document.getElementById("p-kv__bg");
        this.kvLogo = document.getElementById("p-kv__logo");

        if(param.browserType !== 'IE'){
            TweenMax.set(this.kvBg,{ opacity:0,scale:1.08});
            TweenMax.set(this.kvLogo,{ y:0,opacity:0 });
        }

        this.anime = '';

        this.param = param;

    }
    init(){

    }

    splash(){

        if(this.param.browserType !== 'IE') {
            TweenMax.to([this.kvBg, this.kvLogo], 3.2, {
                opacity: 1,
                ease: "Power2.easeOut"
            });
            this.kvBg.classList.add('is-will');
            this.anime = TweenMax.to(this.kvBg, 14, {
                scale: 1,
                ease: "Power2.easeOut",
                className: "+=is-will",
                onComplete: () => {
                    this.kvBg.classList.remove('is-will');
                }
            });
        }

    }

    resize(){

    }

}